import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { ApolloLink } from 'apollo-link'
import axios from 'axios'
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import introspectionQueryResultData from '../mobyGraphqlSchema.json'

import { DRUPAL_HOST } from 'utils/constants'

const GRAPHQL_HOST = `${DRUPAL_HOST}/graphql`
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
})

const create = ({ context, initialState, cacheOptions = {} }) =>
  new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) =>
            // eslint-disable-next-line
            console.error(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            ),
          )
        }

        // eslint-disable-next-line
        if (networkError) {
          console.error(`[Network error]: ${networkError}`)

          // Force cache clear on auth app.
          axios({
            method: 'post',
            url: `${process.env.REACT_APP_AUTH_URL}/clear-cache`,
            crossdomain: true,
          })
            .then(response => window.location.reload())
            .catch(error => {
              console.log(error)
            })
        }
      }),
      new HttpLink({
        uri: GRAPHQL_HOST,
        credentials: 'include',
      }),
    ]),

    cache: new InMemoryCache({ fragmentMatcher }),
  })

// Client singleton
let apolloClient = null

/**
 * Initialize ApolloClient for either server ou client side.
 *
 * @param {Object} options.initialState
 * @param {Object} options.context
 * @param {Object} options.cache
 */
export default options => apolloClient || (apolloClient = create(options))
